import { useCallback, useEffect, useState } from 'react'

import {
  GET_COMPENSATION_WITHDRAW_ORDERS_NEW,
  convertParams as convertParamsForNew,
  convertResult as convertResultForNew,
} from 'app/common/api/requests/cabinet/compensation/withdraw_orders/new/get'

import {
  GET_COMPENSATION_WITHDRAW_ORDERS_SHOW,
  convertParams,
  convertResult,
} from 'app/common/api/requests/cabinet/compensation/withdraw_orders/show/get'

import { api } from 'app/api'
import { Params, ParamsNew, WithdrawToParentType } from 'app/dataTypes/cafeteria/compensation/withdraw/toParent'
import { path } from 'ramda'


const conditionalRequest = async (params: {
  withdrawID: string | null,
  studentID: string | null,
  supplierID: string | null,
}, onSpecialError: (e: string) => void) => {
  onSpecialError('')
  const { withdrawID, studentID, supplierID } = params
  if (withdrawID) {
    const res = await api.request(GET_COMPENSATION_WITHDRAW_ORDERS_SHOW, {
      error: 'Не удалось получить данные заявки',
      params: {
        withdrawID,
      },
      convertions: {
        convertParams,
        convertResult,
      },
    })
    return res
  }
  if (studentID && supplierID) {
    const res = await api.request(GET_COMPENSATION_WITHDRAW_ORDERS_NEW, {
      error: (err) => {
        const status = path(['response', 'status'], err)
        const message = path(['response', 'data', 'message'], err)
        if (status === 422 && message === 'Not enough funds to withdraw') {
          onSpecialError('Нет доступных средств на вывод')
          return ''
        }
        return 'Не удалось получить данные для подготовки заявки на вывод'
      },
      params: { studentID, supplierID },
      convertions: {
        convertParams: convertParamsForNew,
        convertResult: convertResultForNew,
      },
    })
    return res
  }
  return null
}


type Options = {
  params: Params | ParamsNew
  autoload?: boolean
}

const defaultOptions = {
  autoload: true,
}

export function useWithdrawToParent(options: Options) {
  const { autoload, params } = { ...defaultOptions, ...options }

  const [error, setError] = useState('')

  const { studentID, supplierID } = 'studentID' in params ? params : { studentID: null, supplierID: null }
  const { withdrawID } = 'withdrawID' in params ? params : { withdrawID: null }

  const [data, setData] = useState<WithdrawToParentType | null>(null)
  const [loading, setLoading] = useState(true)

  const request = useCallback(async () => {
    setLoading(true)
    const res = await conditionalRequest({ withdrawID, studentID, supplierID }, setError)
    setLoading(false)
    setData(res)
  }, [studentID, supplierID, withdrawID])

  useEffect(() => {
    if (autoload) {
      request()
    }
  }, [request, autoload])

  return { data, loading, error }
}
